<template>
  <div class="elevation-1 group">
    <!-- Item -->
    <draggable :options="{ delay: dragDelay }">
      <v-layout
        class="px-3 item"
        v-for="(item, index) in items"
        :key="index"
        column
        justify-center
        @click.stop="openFolder(item.id)"
        @dragstart="startDrag(item.id)"
        @dragend="setDraggingItem(null)"
        @mousedown="startTimer(folder.id)"
        @mouseup="stopTimer"
        @mouseleave="stopTimer"
        :class="{ 'dragging': folder.id === draggingItemId }"
      >
        <!-- Folder Info -->
        <v-layout
          class="my-2"
          align-center
          justify-space-between
          wrap
          row
        >
          <v-flex class="px-2">
            <v-layout align-center>
              <img
                class="d-flex ml-2 mr-3 folder-icon"
                src="/static/images/folder/folder-closed-icon.svg"
                alt="Ícone de Pasta"
              />
              <v-layout column>
                <div class="grey--text">
                  <strong class="process-number caption">{{ item.process_number }}</strong>
                </div>
                <span class="folder-type-name">{{ item.folder_type.name }}</span>
              </v-layout>
            </v-layout>
          </v-flex>

          <v-flex class="px-2" xs2>
            <v-chip color="grey-lighten-2 entity-chip">
              <v-avatar size="8" color="white">
                <v-icon size="16" color="grey">mdi-briefcase</v-icon>
              </v-avatar>
              <strong class="grey--text text--darken-2 text-truncate">
                {{ item.entity.name }}
              </strong>
            </v-chip>
          </v-flex>

          <v-flex class="px-2" xs3>
            <v-list class="mt-2 user-card">
              <v-list-tile avatar>
                <v-list-tile-avatar color="grey" size="24">
                  <img
                    alt="Avatar"
                    :src="item.current_owner.avatar.url"
                    v-if="item.current_owner.avatar.url"
                  />
                  <span v-else>{{ acronym(item.current_owner.name) }}</span>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title>{{ shortName(item.current_owner.name) }}</v-list-tile-title>
                  <v-list-tile-sub-title class="role">{{ item.current_owner.role.name }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-flex>

          <v-flex class="px-2" xs2>
            <v-icon
              v-if="!isEmpty(item.limit_date)"
              size="22"
              class="mr-2"
            >
              mdi-clock-fast
            </v-icon>
            <span class="caption">
              {{ item.limit_date ? item.limit_date :'Prazo não definido' }}
            </span>
          </v-flex>

          <v-flex class="px-2">
            <v-icon
              v-if="item.received_status === 'Recebido'"
              color="green"
              size="22"
              class="mr-2"
            >
              mdi-check-all
            </v-icon>
            <v-icon
              v-if="item.received_status === 'Recusado'"
              color="red"
              size="22"
              class="mr-2"
            >
              mdi-alert-circle-outline
            </v-icon>
            <span
              v-if="item.received_status === 'Recebido'"
              class="green--text caption"
            >
              {{ item.received_status }}
            </span>
            <span
              v-else-if="item.received_status === 'Não Recebido'"
              class="grey--text caption"
            >
              Aguardando
            </span>
            <span
              v-else-if="item.received_status === 'Recusado'"
              class="red--text caption"
            >
              {{ item.received_status }}
            </span>
            <span class="caption" v-else>Sem status</span>
          </v-flex>
        </v-layout>

        <!-- Document Details -->
        <v-layout class="grey lighten-3 mb-3 document-details">
          <v-icon
            class="has-pending"
            size="8"
            :style="{'color': item.pending_type === 'review' ? colors.amber.base : colors.blue.base}"
          >
            mdi mdi-circle
          </v-icon>
          <v-layout justify-start align-center>
            <span class="caption mx-3 grey--text text--darken-3">
              {{ item.pending_type === 'review' ? 'Revisão' : 'Assinatura' }} Solicitada
            </span>

            <div class="d-flex align-end" v-if="getDocumentPendingFolder(item)">
              <v-icon color="black" class="mr-1">mdi-file-document-outline</v-icon>
              <span>{{getDocumentPendingFolder(item).document_type.name}}</span>
            </div>

            <v-btn
              small
              flat
              color="blue"
              @click.stop="showDocument(item, getDocumentPendingFolder(item))"
            >
              Visualizar
            </v-btn>
          </v-layout>
        </v-layout>

        <span
          class="folder-border"
          :style="{ 'background':  item.pending_type === 'review' ? colors.amber.base : colors.blue.base }"
        ></span>
      </v-layout>
    </draggable>
  </div>
</template>

<script>
import { isEmpty, truncate } from "lodash";
import shortName from "@/utils/short-name";
import acronym from "@/utils/acronym";
import colors from "vuetify/es5/util/colors";
import draggable from "vuedraggable";

export default {
  name: "pending-items-table",
  props: ["items", "doc"],
  components: {
    draggable
  },
  data() {
    return {
      acronym,
      colors,
      isEmpty,
      shortName,
      truncate,
      draggingItemId: null,
      timer: null,
      dragDelay: 1500
    };
  },
  methods: {
    startDrag(id) {
      this.$store.commit("setDraggingFolder", id);
    },
    startTimer(id) {
      this.timer = setTimeout(() => {
        this.setDraggingItem(id);
      }, this.dragDelay);
    },
    stopTimer() {
      clearTimeout(this.timer);
      this.setDraggingItem(null);
    },
    setDraggingItem(id) {
      this.draggingItemId = id;
    },
    truncateEntityName(entityName) {
      if (this.$vuetify.breakpoint.lgOnly) {
        return truncate(entityName, { length: 25 });
      }
      if (this.$vuetify.breakpoint.xlOnly) {
        return truncate(entityName, { length: 50 });
      }
      return truncate(entityName, { length: 15 });
    },
    openFolder(id) {
      const route = this.$router.resolve(`/pastas/${id}/show`);
      window.open(route.href, "_blank");
    },
    getDocumentPendingFolder(folder) {
      const docs = folder.documents.filter(
        d =>
          d.has_pending_signatures === true || d.has_pending_revision === true
      );
      return docs[0];
    },
    showDocument(folder, document) {
      const route = this.$router.resolve({
        path: `/pastas/${folder.id}/show`,
        query: { documentId: document.id }
      });
      window.open(route.href, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-table {
  position: relative;
  border-bottom: solid 1px #dadce0;
  cursor: pointer;
  &:last-child {
    border: none;
  }
}
.custom-table:hover {
  border-radius: 3px 0 0 3px;
  .folder-type-border {
    left: -4px;
    border-left: 5px solid #e0e0e0;
  }
}
.document-details {
  border-radius: 2px;
  position: relative;
}
.inverted {
  transform: rotate(360deg) scaleX(-1);
}
.v-list,
.v-list__tile--avatar,
.v-list__tile__content {
  height: 48px;
}
.v-list {
  padding: 0;
  background: transparent;
  margin-top: -8px;
}
.folder-type-border {
  z-index: 1;
  position: absolute;
  height: 100%;
  top: 0;
  left: -2px;
  border-radius: 3px 0 0 3px;
  border-left: 3px solid #e0e0e0;
  transition: ease-in-out 0.15s;
}
.has-pending {
  z-index: 2;
  position: absolute;
  top: calc(50% - 5px);
  left: -4px;
  background: #fff;
  border: 2px solid #fff;
  border-radius: 50%;
  height: 10px;
  width: 10px;
}

.dragging {
  background-color: #005ece;
}
</style>



// WEBPACK FOOTER //
// src/components/base/PendingItemsTable.vue